import {
    GlobalNav,
    GlobalNavDrawers,
    SiteHeader,
} from '@99designs/common/apps/global-nav/GlobalNav';
import { Site } from '@99designs/common/apps/global-nav/lib/Site';
import defaultSite from '@99designs/shared-configuration/dist/sites/99designs.com.json';
import CreateContext from 'projects/components/CreateContext';
import SiteFooter from 'projects/components/SiteFooter';
import * as React from 'react';

interface Props {
    children?: React.ReactNode;
    variations?: string[];
}

const Layout = ({ children, variations }: Props) => (
    <CreateContext.Consumer>
        {({ site, role }) => (
            <GlobalNav>
                {({ toggleDrawer, drawerState }) => {
                    const globalNavSite = new Site(
                        site
                            ? {
                                  domain: site.domain,
                                  'phone.support': site.phoneSupport,
                                  'phone.office_hours': site.phoneOfficeHours
                                      ? site.phoneOfficeHours
                                      : '',
                                  locale: site.locale,
                                  accepted_locales: site.acceptedLocales.map(
                                      acceptedLocale => acceptedLocale.tag
                                  ),
                              }
                            : defaultSite
                    );

                    return (
                        <div
                            className={`layout ${variations &&
                                variations.map(v => `layout--${v}`)}`}
                        >
                            {role && globalNavSite && (
                                <div className="max--desktop">
                                    <SiteHeader
                                        role={role}
                                        site={globalNavSite}
                                        variations={[]}
                                        onLeftDrawerTriggerClick={toggleDrawer('left', true)}
                                        onRightDrawerTriggerClick={toggleDrawer('right', true)}
                                        focused
                                    />
                                </div>
                            )}
                            <div className="layout__content">{children}</div>
                            {role && globalNavSite && (
                                <GlobalNavDrawers
                                    toggleDrawer={toggleDrawer}
                                    role={role}
                                    site={globalNavSite}
                                    drawerState={drawerState}
                                />
                            )}
                            <div className="layout__footer">
                                <div className="max--desktop">
                                    <div className="row">
                                        <SiteFooter />
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                }}
            </GlobalNav>
        )}
    </CreateContext.Consumer>
);
export default Layout;
